import { useAuthStore, useQueryWithUserId } from '@northladder/services';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';
import { IFetchPaginatedAppraisalsPayload } from '../types';

/**
 * This is to track the download appraisals query key in react query cache.
 */
const DOWNLOAD_APPRAISALS_QUERY = 'download-appraisals-query-key';

/**
 * Handles the API call to download the appraisals.
 * TODO: handle loading state for this content
 */
export const useDownloadAppraisalsQuery = (
  payload: IFetchPaginatedAppraisalsPayload
) => {
  const {
    brandId,
    categoryId,
    count,
    dealProcessType,
    fromDate,
    listType,
    search,
    toDate,
    userId: idUser,
  } = payload;
  const userId = idUser || useAuthStore.getState()?.activeSession?.userId || '';

  const localPayload = {
    dealProcessType,
    count,
    listType,
    userId,
    // If the categoryId or brandiId is 'all', we don't need to pass it in the payload.
    ...(brandId && brandId !== 'all' ? { brandId } : {}),
    ...(categoryId && categoryId !== 'all' ? { categoryId } : {}),
    ...(fromDate ? { fromDate } : {}),
    ...(search ? { search } : {}),
    ...(toDate ? { toDate } : {}),
  };

  const {
    data,
    error,
    isError,
    refetch: callDownloadAppraisalsAPI,
  } = useQueryWithUserId({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [DOWNLOAD_APPRAISALS_QUERY],
    enabled: false,
    queryFn: ({ pageParam = 1 }) =>
      CUSTOMER_SERVICE_API.downloadAppraisals({
        ...localPayload,
        page: pageParam as number,
      }),
  });

  return {
    data,
    error,
    isError,
    callDownloadAppraisalsAPI,
  };
};
